import _ from 'lodash'

function makeButtonVersion(bannerType) {
  let copy = JSON.parse(JSON.stringify(bannerType))
  for (let i = 0; i < copy.length; i++) {
    let keys = Object.keys(copy[i].slot)
    for (const key of keys) {
      if (copy[i].slot[key].content.type === 'link') {
        copy[i].slot[key].content.type = 'button'
      }
    }
  }
  return copy
}

const bannerLeft = [
  {
    slot: {
      '0': {
        area: 'fill',
        classes: '',
        content: {
          type: 'image',
          url: '{bgMobile}',
          hasWebp: '{bgMobilePortraitHasWebp}',
          classes: 'bgp-c'
        }
      },
      '425': {
        area: 'fill',
        classes: '',
        content: {
          type: 'image',
          url: '{bgMobileLandscape}',
          hasWebp: '{bgMobileLandscapeHasWebp}',
          classes: 'bgp-c'
        }
      },
      '1024': {
        area: 'fill',
        classes: '',
        content: {
          type: 'image',
          url: '{bgDesktop}',
          hasWebp: '{bgDesktopHasWebp}',
          classes: 'bgp-b'
        }
      }
    }
  },
  {
    slot: {
      '0': {
        area: 'ltt',
        classes: '',
        content: {
          type: 'spacer',
          space: '1rem'
        }
      },
      '665': {
        area: 'ltt',
        classes: '',
        content: {
          type: 'spacer',
          space: '2rem'
        }
      }
    }
  },
  {
    slot: {
      '0': {
        area: 'lt',
        classes: 'w-1/1 maw-36rem ml-4 ',
        content: {
          type: 'text',
          textlines: [
            {
              text: '{textline1}',
              classes: 'p0 {textColor} fw-800 fz-title-m lh-120 ta-l'
            },
            {
              text: '{textline2}',
              classes: 'p0 {textColor} fw-800 fz-title-m lh-120 ta-l'
            },
            {
              text: '{textline3}',
              classes: 'p0 {textColor} fw-800 fz-title-m lh-120 ta-l'
            },
            {
              text: '{textline4}',
              classes: 'p0 {textColor} fw-800 fz-title-m lh-120 ta-l'
            },
            {
              text: '{textline5}',
              classes: 'p0 {textColor} fw-600 fz-body-m lh-120 ta-l mt-1'
            },
            {
              text: '{textline6}',
              classes: 'p0 {textColor} fw-600 fz-body-m lh-120 ta-l'
            },
            {
              text: '{textline7}',
              classes: 'p0 {textColor} fw-600 fz-body-m lh-120 ta-l'
            },
            {
              text: '{textline8}',
              classes: 'p0 {textColor} fw-600 fz-body-m lh-120 ta-l'
            }
          ]
        }
      },
      '665': {
        area: 'lt',
        classes: 'w-1/1 maw-36rem ml-7 ',
        content: {
          type: 'text',
          textlines: [
            {
              text: '{textline1}',
              classes: 'p0 {textColor} fw-800 fz-title-t lh-120 ta-l'
            },
            {
              text: '{textline2}',
              classes: 'p0 {textColor} fw-800 fz-title-t lh-120 ta-l'
            },
            {
              text: '{textline3}',
              classes: 'p0 {textColor} fw-800 fz-title-t lh-120 ta-l'
            },
            {
              text: '{textline4}',
              classes: 'p0 {textColor} fw-800 fz-title-t lh-120 ta-l'
            },
            {
              text: '{textline5}',
              classes: 'p0 {textColor} fw-600 fz-body-t lh-120 ta-l mt-1'
            },
            {
              text: '{textline6}',
              classes: 'p0 {textColor} fw-600 fz-body-t lh-120 ta-l'
            },
            {
              text: '{textline7}',
              classes: 'p0 {textColor} fw-600 fz-body-t lh-120 ta-l'
            },
            {
              text: '{textline8}',
              classes: 'p0 {textColor} fw-600 fz-body-t lh-120 ta-l'
            }
          ]
        }
      },
      '768': {
        area: 'lt',
        classes: 'w-1/1 maw-36rem ml-10',
        content: {
          type: 'text',
          textlines: [
            {
              text: '{textline1}',
              classes: 'p0 {textColor} fw-800 fz-title-t lh-120 ta-l'
            },
            {
              text: '{textline2}',
              classes: 'p0 {textColor} fw-800 fz-title-t lh-120 ta-l'
            },
            {
              text: '{textline3}',
              classes: 'p0 {textColor} fw-800 fz-title-t lh-120 ta-l'
            },
            {
              text: '{textline4}',
              classes: 'p0 {textColor} fw-800 fz-title-t lh-120 ta-l'
            },
            {
              text: '{textline5}',
              classes: 'p0 {textColor} fw-600 fz-body-t lh-120 ta-l mt-1'
            },
            {
              text: '{textline6}',
              classes: 'p0 {textColor} fw-600 fz-body-t lh-120 ta-l'
            },
            {
              text: '{textline7}',
              classes: 'p0 {textColor} fw-600 fz-body-t lh-120 ta-l'
            },
            {
              text: '{textline8}',
              classes: 'p0 {textColor} fw-600 fz-body-t lh-120 ta-l'
            }
          ]
        }
      },
      '1170': {
        area: 'lt',
        classes: 'w-1/1 w-39rem ml-7',
        content: {
          type: 'text',
          textlines: [
            {
              text: '{textline1}',
              classes: 'p0 {textColor} fw-800 fz-title-d lh-100 ta-l'
            },
            {
              text: '{textline2}',
              classes: 'p0 {textColor} fw-800 fz-title-d lh-100 ta-l'
            },
            {
              text: '{textline3}',
              classes: 'p0 {textColor} fw-800 fz-title-d lh-100 ta-l'
            },
            {
              text: '{textline4}',
              classes: 'p0 {textColor} fw-800 fz-title-d lh-100 ta-l'
            },
            {
              text: '{textline5}',
              classes: 'p0 {textColor} fw-600 fz-body-d lh-120 ta-l mt-1'
            },
            {
              text: '{textline6}',
              classes: 'p0 {textColor} fw-600 fz-body-d lh-120 ta-l'
            },
            {
              text: '{textline7}',
              classes: 'p0 {textColor} fw-600 fz-body-d lh-120 ta-l'
            },
            {
              text: '{textline8}',
              classes: 'p0 {textColor} fw-600 fz-body-d lh-120 ta-l'
            }
          ]
        }
      },
      '1440': {
        area: 'lt',
        classes: 'w-1/1 maw-41rem ml-19',
        content: {
          type: 'text',
          textlines: [
            {
              text: '{textline1}',
              classes: '{textColor} fw-800 fz-title-d lh-120 ta-l'
            },
            {
              text: '{textline2}',
              classes: '{textColor} fw-800 fz-title-d lh-120 ta-l'
            },
            {
              text: '{textline3}',
              classes: '{textColor} fw-800 fz-title-d lh-120 ta-l'
            },
            {
              text: '{textline4}',
              classes: '{textColor} fw-800 fz-title-d lh-120 ta-l'
            },
            {
              text: '{textline5}',
              classes: '{textColor} fw-600 fz-body-d lh-120 ta-l mt-1'
            },
            {
              text: '{textline6}',
              classes: '{textColor} fw-600 fz-body-d lh-120 ta-l'
            },
            {
              text: '{textline7}',
              classes: '{textColor} fw-600 fz-body-d lh-120 ta-l'
            },
            {
              text: '{textline8}',
              classes: '{textColor} fw-600 fz-body-d lh-120 ta-l'
            }
          ]
        }
      }
    }
  },
  {
    slot: {
      '0': {
        area: 'l',
        classes: 'w-1/1 maw-36rem ml-4 ph p0 mt-- ',
        content: {
          type: 'link',
          text: '{ctaText}',
          action: '{ctaButtonAction}',
          url: '{ctaUrl}',
          classes: '{ctaColor} {ctaHoverColor} w-9rem fz-cta-m ta-c pv--'
        }
      },
      '665': {
        area: 'l',
        classes: 'w-1/1 maw-36rem ml-7 ph p0 mt-- ',
        content: {
          type: 'link',
          text: '{ctaText}',
          action: '{ctaButtonAction}',
          url: '{ctaUrl}',
          classes: ' {ctaColor} {ctaHoverColor} w-12rem fz-cta-t ta-c'
        }
      },
      '768': {
        area: 'l',
        classes: 'w-1/1 maw-36rem ml-7 ph+ mt--',
        content: {
          type: 'link',
          text: '{ctaText}',
          action: '{ctaButtonAction}',
          url: '{ctaUrl}',
          classes: '{ctaColor} {ctaHoverColor} w-12rem fz-cta-t ta-c'
        }
      },
      '1170': {
        area: 'l',
        classes: 'w-1/1 maw-39rem ml-7 ph+ p0 mt--',
        content: {
          type: 'link',
          text: '{ctaText}',
          action: '{ctaButtonAction}',
          url: '{ctaUrl}',
          classes: '{ctaColor} {ctaHoverColor} w-12rem fz-cta-d ta-c'
        }
      },
      '1440': {
        area: 'l',
        classes: 'w-1/1 maw-41rem ml-19 ph+ mt--',
        content: {
          type: 'link',
          text: '{ctaText}',
          action: '{ctaButtonAction}',
          url: '{ctaUrl}',
          classes: '{ctaColor} {ctaHoverColor} w-18rem fz-cta-d ta-c'
        }
      }
    }
  },
  {
    slot: {
      '0': {
        area: 'lb',
        classes: 'w-1/1 maw-27rem ml-4 ',
        content: {
          type: 'text',
          textlines: [
            {
              text: '{textline9}',
              classes: 'p0 {textColor}  fz-legal-m lh-120 ta-l'
            },
            {
              text: '{textline10}',
              classes: 'p0 {textColor}  fz-legal-m lh-120 ta-l'
            },
            {
              text: '{textline11}',
              classes: 'p0 {textColor}  fz-legal-m lh-120 ta-l'
            },
            {
              text: '{textline12}',
              classes: 'p0 {textColor}  fz-legal-m lh-120 ta-l'
            }
          ]
        }
      },
      '665': {
        area: 'lb',
        classes: 'w-1/1 maw-36rem ml-7 ',
        content: {
          type: 'text',
          textlines: [
            {
              text: '{textline9}',
              classes: 'p0 {textColor}  fz-legal-t lh-120 ta-l'
            },
            {
              text: '{textline10}',
              classes: 'p0 {textColor}  fz-legal-t lh-120 ta-l'
            },
            {
              text: '{textline11}',
              classes: 'p0 {textColor}  fz-legal-t lh-120 ta-l'
            },
            {
              text: '{textline12}',
              classes: 'p0 {textColor}  fz-legal-t lh-120 ta-l'
            }
          ]
        }
      },
      '768': {
        area: 'lb',
        classes: 'w-1/1 maw-36rem ml-10',
        content: {
          type: 'text',
          textlines: [
            {
              text: '{textline9}',
              classes: 'p0 {textColor}  fz-legal-t lh-120 ta-l'
            },
            {
              text: '{textline10}',
              classes: 'p0 {textColor}  fz-legal-t lh-120 ta-l'
            },
            {
              text: '{textline11}',
              classes: 'p0 {textColor}  fz-legal-t lh-120 ta-l'
            },
            {
              text: '{textline12}',
              classes: 'p0 {textColor}  fz-legal-t lh-120 ta-l'
            }
          ]
        }
      },
      '1170': {
        area: 'lb',
        classes: 'w-1/1 w-39rem ml-7',
        content: {
          type: 'text',
          textlines: [
            {
              text: '{textline9}',
              classes: 'p0 {textColor}  fz-legal-d lh-120 ta-l'
            },
            {
              text: '{textline10}',
              classes: 'p0 {textColor}  fz-legal-d lh-120 ta-l'
            },
            {
              text: '{textline11}',
              classes: 'p0 {textColor}  fz-legal-d lh-120 ta-l'
            },
            {
              text: '{textline12}',
              classes: 'p0 {textColor}  fz-legal-d lh-120 ta-l'
            }
          ]
        }
      },
      '1440': {
        area: 'lb',
        classes: 'w-1/1 maw-41rem ml-19',
        content: {
          type: 'text',
          textlines: [
            {
              text: '{textline9}',
              classes: '{textColor}  fz-legal-d lh-120 ta-l'
            },
            {
              text: '{textline10}',
              classes: '{textColor}  fz-legal-d lh-120 ta-l'
            },
            {
              text: '{textline11}',
              classes: '{textColor}  fz-legal-d lh-120 ta-l'
            },
            {
              text: '{textline12}',
              classes: '{textColor}  fz-legal-d lh-120 ta-l'
            }
          ]
        }
      }
    }
  },
  {
    slot: {
      '0': {
        area: 'lbb',
        classes: '',
        content: {
          type: 'spacer',
          space: '1rem'
        }
      },
      '665': {
        area: 'lbb',
        classes: '',
        content: {
          type: 'spacer',
          space: '2rem'
        }
      }
    }
  }
]

const bannerLeftButton = makeButtonVersion(bannerLeft)

const bannerCenter = [
  {
    slot: {
      '0': {
        area: 'fill',
        classes: '',
        content: {
          type: 'image',
          url: '{bgMobile}',
          hasWebp: '{bgMobilePortraitHasWebp}',
          classes: 'bgp-c'
        }
      },
      '425': {
        area: 'fill',
        classes: '',
        content: {
          type: 'image',
          url: '{bgMobileLandscape}',
          hasWebp: '{bgMobileLandscapeHasWebp}',
          classes: 'bgp-c'
        }
      },
      '1024': {
        area: 'fill',
        classes: '',
        content: {
          type: 'image',
          url: '{bgDesktop}',
          hasWebp: '{bgDesktopHasWebp}',
          classes: 'bgp-b'
        }
      }
    }
  },
  {
    slot: {
      '0': {
        area: 'ctt',
        classes: '',
        content: {
          type: 'spacer',
          space: '0rem'
        }
      },
      '665': {
        area: 'ctt',
        classes: '',
        content: {
          type: 'spacer',
          space: '2rem'
        }
      }
    }
  },
  {
    slot: {
      '0': {
        area: 'ct',
        classes: 'w-1/1 maw-24rem  mt-',
        content: {
          type: 'text',
          textlines: [
            {
              text: '{textline1}',
              classes: '{textColor} fw-800 fz-title-m lh-120 ta-c'
            },
            {
              text: '{textline2}',
              classes: '{textColor} fw-800 fz-title-m lh-120 ta-c'
            },
            {
              text: '{textline3}',
              classes: '{textColor} fw-800 fz-title-m lh-120 ta-c'
            },
            {
              text: '{textline4}',
              classes: '{textColor} fw-800 fz-title-m lh-120 ta-c'
            },
            {
              text: '{textline5}',
              classes: '{textColor} fw-600 fz-body-m lh-120 ta-c mt-1'
            },
            {
              text: '{textline6}',
              classes: '{textColor} fw-600 fz-body-m lh-120 ta-c'
            },
            {
              text: '{textline7}',
              classes: '{textColor} fw-600 fz-body-m lh-120 ta-c'
            },
            {
              text: '{textline8}',
              classes: '{textColor} fw-600 fz-body-m lh-120 ta-c'
            }
          ]
        }
      },
      '665': {
        area: 'ct',
        classes: 'w-1/1 w-24rem  mtn+',
        content: {
          type: 'text',
          textlines: [
            {
              text: '{textline1}',
              classes: '{textColor} fw-800 fz-title-t lh-120 ta-c'
            },
            {
              text: '{textline2}',
              classes: '{textColor} fw-800 fz-title-t lh-120 ta-c'
            },
            {
              text: '{textline3}',
              classes: '{textColor} fw-800 fz-title-t lh-120 ta-c'
            },
            {
              text: '{textline4}',
              classes: '{textColor} fw-800 fz-title-t lh-120 ta-c'
            },
            {
              text: '{textline5}',
              classes: '{textColor} fw-600 fz-body-t lh-120 ta-c mt-1'
            },
            {
              text: '{textline6}',
              classes: '{textColor} fw-600 fz-body-t lh-120 ta-c'
            },
            {
              text: '{textline7}',
              classes: '{textColor} fw-600 fz-body-t lh-120 ta-c'
            },
            {
              text: '{textline8}',
              classes: '{textColor} fw-600 fz-body-t lh-120 ta-c'
            }
          ]
        }
      },
      '768': {
        area: 'ct',
        classes: 'w-1/1 maw-36rem ',
        content: {
          type: 'text',
          textlines: [
            {
              text: '{textline1}',
              classes: '{textColor} fw-800 fz-title-t lh-120 ta-c'
            },
            {
              text: '{textline2}',
              classes: '{textColor} fw-800 fz-title-t lh-120 ta-c'
            },
            {
              text: '{textline3}',
              classes: '{textColor} fw-800 fz-title-t lh-120 ta-c'
            },
            {
              text: '{textline4}',
              classes: '{textColor} fw-800 fz-title-t lh-120 ta-c'
            },
            {
              text: '{textline5}',
              classes: '{textColor} fw-600 fz-body-t lh-120 ta-c mt-1'
            },
            {
              text: '{textline6}',
              classes: '{textColor} fw-600 fz-body-t lh-120 ta-c'
            },
            {
              text: '{textline7}',
              classes: '{textColor} fw-600 fz-body-t lh-120 ta-c'
            },
            {
              text: '{textline8}',
              classes: '{textColor} fw-600 fz-body-t lh-120 ta-c'
            }
          ]
        }
      },
      '1170': {
        area: 'ct',
        classes: 'w-1/1 w-39rem ',
        content: {
          type: 'text',
          textlines: [
            {
              text: '{textline1}',
              classes: '{textColor} fw-800 fz-title-d lh-100 ta-c'
            },
            {
              text: '{textline2}',
              classes: '{textColor} fw-800 fz-title-d lh-100 ta-c'
            },
            {
              text: '{textline3}',
              classes: '{textColor} fw-800 fz-title-d lh-100 ta-c'
            },
            {
              text: '{textline4}',
              classes: '{textColor} fw-800 fz-title-d lh-100 ta-c'
            },
            {
              text: '{textline5}',
              classes: '{textColor} fw-600 fz-body-d lh-120 ta-c mt-1'
            },
            {
              text: '{textline6}',
              classes: '{textColor} fw-600 fz-body-d lh-120 ta-c'
            },
            {
              text: '{textline7}',
              classes: '{textColor} fw-600 fz-body-d lh-120 ta-c'
            },
            {
              text: '{textline8}',
              classes: '{textColor} fw-600 fz-body-d lh-120 ta-c'
            }
          ]
        }
      },
      '1440': {
        area: 'ct',
        classes: 'w-1/1 maw-41rem ',
        content: {
          type: 'text',
          textlines: [
            {
              text: '{textline1}',
              classes: '{textColor} fw-800 fz-title-d lh-120 ta-c'
            },
            {
              text: '{textline2}',
              classes: '{textColor} fw-800 fz-title-d lh-120 ta-c'
            },
            {
              text: '{textline3}',
              classes: '{textColor} fw-800 fz-title-d lh-120 ta-c'
            },
            {
              text: '{textline4}',
              classes: '{textColor} fw-800 fz-title-d lh-120 ta-c'
            },
            {
              text: '{textline5}',
              classes: '{textColor} fw-600 fz-body-d lh-120 ta-c mt-1'
            },
            {
              text: '{textline6}',
              classes: '{textColor} fw-600 fz-body-d lh-120 ta-c'
            },
            {
              text: '{textline7}',
              classes: '{textColor} fw-600 fz-body-d lh-120 ta-c'
            },
            {
              text: '{textline8}',
              classes: '{textColor} fw-600 fz-body-d lh-120 ta-c'
            }
          ]
        }
      }
    }
  },
  {
    slot: {
      '0': {
        area: 'c',
        classes: 'w-1/1 maw-21rem  mt-- ta-c',
        content: {
          type: 'link',
          text: '{ctaText}',
          action: '{ctaButtonAction}',
          url: '{ctaUrl}',
          classes: '{ctaColor} {ctaHoverColor} w-9rem fz-cta-m ta-c pv--'
        }
      },
      '665': {
        area: 'c',
        classes: 'w-1/1 maw-24rem  mt-- ta-c',
        content: {
          type: 'link',
          text: '{ctaText}',
          action: '{ctaButtonAction}',
          url: '{ctaUrl}',
          classes: ' {ctaColor} {ctaHoverColor} w-12rem fz-cta-t ta-c'
        }
      },
      '768': {
        area: 'c',
        classes: 'w-1/1 maw-36rem ph mt-- ta-c',
        content: {
          type: 'link',
          text: '{ctaText}',
          action: '{ctaButtonAction}',
          url: '{ctaUrl}',
          classes: '{ctaColor} {ctaHoverColor} w-12rem fz-cta-t ta-c'
        }
      },
      '1170': {
        area: 'c',
        classes: 'w-1/1 maw-39rem  ph+ mt-- ta-c',
        content: {
          type: 'link',
          text: '{ctaText}',
          action: '{ctaButtonAction}',
          url: '{ctaUrl}',
          classes: '{ctaColor} {ctaHoverColor} w-12rem fz-cta-d ta-c'
        }
      },
      '1440': {
        area: 'c',
        classes: 'w-1/1 maw-41rem  ph+ mt-- ta-c',
        content: {
          type: 'link',
          text: '{ctaText}',
          action: '{ctaButtonAction}',
          url: '{ctaUrl}',
          classes: '{ctaColor} {ctaHoverColor} w-18rem fz-cta-d ta-c'
        }
      }
    }
  },
  {
    slot: {
      '0': {
        area: 'cb',
        classes: 'w-1/1 maw-24rem  mt-',
        content: {
          type: 'text',
          textlines: [
            {
              text: '{textline9}',
              classes: 'p0 {textColor} fz-legal-m lh-120 ta-c'
            },
            {
              text: '{textline10}',
              classes: 'p0 {textColor} fz-legal-m lh-120 ta-c'
            },
            {
              text: '{textline11}',
              classes: 'p0 {textColor} fz-legal-m lh-120 ta-c'
            },
            {
              text: '{textline12}',
              classes: 'p0 {textColor} fz-legal-m lh-120 ta-c'
            }
          ]
        }
      },
      '665': {
        area: 'cb',
        classes: 'w-1/1 w-24rem  mtn+',
        content: {
          type: 'text',
          textlines: [
            {
              text: '{textline9}',
              classes: '{textColor}  fz-legal-t lh-120 ta-c mt-3'
            },
            {
              text: '{textline10}',
              classes: '{textColor}  fz-legal-t lh-120 ta-c'
            },
            {
              text: '{textline11}',
              classes: '{textColor}  fz-legal-t lh-120 ta-c'
            },
            {
              text: '{textline12}',
              classes: '{textColor}  fz-legal-t lh-120 ta-c'
            }
          ]
        }
      },
      '768': {
        area: 'cb',
        classes: 'w-1/1 maw-36rem ',
        content: {
          type: 'text',
          textlines: [
            {
              text: '{textline9}',
              classes: '{textColor}  fz-legal-t lh-120 ta-c'
            },
            {
              text: '{textline10}',
              classes: '{textColor}  fz-legal-t lh-120 ta-c'
            },
            {
              text: '{textline11}',
              classes: '{textColor}  fz-legal-t lh-120 ta-c'
            },
            {
              text: '{textline12}',
              classes: '{textColor}  fz-legal-t lh-120 ta-c'
            }
          ]
        }
      },
      '1170': {
        area: 'cb',
        classes: 'w-1/1 w-39rem ',
        content: {
          type: 'text',
          textlines: [
            {
              text: '{textline9}',
              classes: '{textColor}  fz-legal-d lh-120 ta-c'
            },
            {
              text: '{textline10}',
              classes: '{textColor}  fz-legal-d lh-120 ta-c'
            },
            {
              text: '{textline11}',
              classes: '{textColor}  fz-legal-d lh-120 ta-c'
            },
            {
              text: '{textline12}',
              classes: '{textColor}  fz-legal-d lh-120 ta-c'
            }
          ]
        }
      },
      '1440': {
        area: 'cb',
        classes: 'w-1/1 maw-41rem ',
        content: {
          type: 'text',
          textlines: [
            {
              text: '{textline9}',
              classes: '{textColor}  fz-legal-d lh-120 ta-c'
            },
            {
              text: '{textline10}',
              classes: '{textColor}  fz-legal-d lh-120 ta-c'
            },
            {
              text: '{textline11}',
              classes: '{textColor}  fz-legal-d lh-120 ta-c'
            },
            {
              text: '{textline12}',
              classes: '{textColor}  fz-legal-d lh-120 ta-c'
            }
          ]
        }
      }
    }
  },
  {
    slot: {
      '0': {
        area: 'cbb',
        classes: '',
        content: {
          type: 'spacer',
          space: '0rem'
        }
      },
      '665': {
        area: 'cbb',
        classes: '',
        content: {
          type: 'spacer',
          space: '2rem'
        }
      }
    }
  }
]

const bannerCenterButton = makeButtonVersion(bannerCenter)

// Keep for future implementation
const bannerRight = []

const bannerRightButton = makeButtonVersion(bannerRight)

// Timer
const bannerTimer = [
  {
    slot: {
      '0': {
        area: 'fill',
        classes: '',
        content: {
          type: 'image',
          url: '{bgMobile}',
          hasWebp: '{bgMobilePortraitHasWebp}',
          classes: 'bgp-c'
        }
      },
      '425': {
        area: 'fill',
        classes: '',
        content: {
          type: 'image',
          url: '{bgMobileLandscape}',
          hasWebp: '{bgMobileLandscapeHasWebp}',
          classes: 'bgp-c'
        }
      },
      '1024': {
        area: 'fill',
        classes: '',
        content: {
          type: 'image',
          url: '{bgDesktop}',
          hasWebp: '{bgDesktopHasWebp}',
          classes: 'bgp-b'
        }
      }
    }
  },
  {
    slot: {
      '0': {
        area: 'ctt',
        classes: '',
        content: {
          type: 'spacer',
          space: '0rem'
        }
      },
      '665': {
        area: 'ctt',
        classes: '',
        content: {
          type: 'spacer',
          space: '2rem'
        }
      }
    }
  },
  {
    slot: {
      '0': {
        area: 'ct',
        classes: 'w-1/1 maw-24rem  mt-',
        content: {
          type: 'text',
          textlines: [
            {
              text: '{textline1}',
              classes: '{textColor} fw-800 fz-title-m lh-120 ta-c'
            },
            {
              text: '{textline2}',
              classes: '{textColor} fw-800 fz-title-m lh-120 ta-c'
            },
            {
              text: '{textline3}',
              classes: '{textColor} fw-800 fz-title-m lh-120 ta-c'
            },
            {
              text: '{textline4}',
              classes: '{textColor} fw-800 fz-title-m lh-120 ta-c'
            }
          ]
        }
      },
      '665': {
        area: 'ct',
        classes: 'w-1/1 w-24rem  mtn+',
        content: {
          type: 'text',
          textlines: [
            {
              text: '{textline1}',
              classes: '{textColor} fw-800 fz-title-t lh-120 ta-c'
            },
            {
              text: '{textline2}',
              classes: '{textColor} fw-800 fz-title-t lh-120 ta-c'
            },
            {
              text: '{textline3}',
              classes: '{textColor} fw-800 fz-title-t lh-120 ta-c'
            },
            {
              text: '{textline4}',
              classes: '{textColor} fw-800 fz-title-t lh-120 ta-c'
            }
          ]
        }
      },
      '768': {
        area: 'ct',
        classes: 'w-1/1 maw-36rem ',
        content: {
          type: 'text',
          textlines: [
            {
              text: '{textline1}',
              classes: '{textColor} fw-800 fz-title-t lh-120 ta-c'
            },
            {
              text: '{textline2}',
              classes: '{textColor} fw-800 fz-title-t lh-120 ta-c'
            },
            {
              text: '{textline3}',
              classes: '{textColor} fw-800 fz-title-t lh-120 ta-c'
            },
            {
              text: '{textline4}',
              classes: '{textColor} fw-800 fz-title-t lh-120 ta-c'
            }
          ]
        }
      },
      '1170': {
        area: 'ct',
        classes: 'w-1/1 w-39rem ',
        content: {
          type: 'text',
          textlines: [
            {
              text: '{textline1}',
              classes: '{textColor} fw-800 fz-title-d lh-100 ta-c'
            },
            {
              text: '{textline2}',
              classes: '{textColor} fw-800 fz-title-d lh-100 ta-c'
            },
            {
              text: '{textline3}',
              classes: '{textColor} fw-800 fz-title-d lh-100 ta-c'
            },
            {
              text: '{textline4}',
              classes: '{textColor} fw-800 fz-title-d lh-100 ta-c'
            }
          ]
        }
      },
      '1440': {
        area: 'ct',
        classes: 'w-1/1 maw-41rem ',
        content: {
          type: 'text',
          textlines: [
            {
              text: '{textline1}',
              classes: '{textColor} fw-800 fz-title-d lh-120 ta-c'
            },
            {
              text: '{textline2}',
              classes: '{textColor} fw-800 fz-title-d lh-120 ta-c'
            },
            {
              text: '{textline3}',
              classes: '{textColor} fw-800 fz-title-d lh-120 ta-c'
            },
            {
              text: '{textline4}',
              classes: '{textColor} fw-800 fz-title-d lh-120 ta-c'
            }
          ]
        }
      }
    }
  },
  {
    slot: {
      '0': {
        area: 'c',
        classes: 'w-1/1 maw-24rem  mt-',
        content: {
          type: 'timer',
          deadline: '{deadline}',
          text: '{timerText}',
          expiredText: '{expiredText}',
          classes: 'p0 {textColor} fw-800 fz-title-m lh-120 ta-c'
        }
      },
      '665': {
        area: 'c',
        classes: 'w-1/1 maw-24rem  mt-',
        content: {
          type: 'timer',
          deadline: '{deadline}',
          text: '{timerText}',
          expiredText: '{expiredText}',
          classes: 'p0 {textColor} fw-800 fz-title-t lh-120 ta-c'
        }
      },
      '768': {
        area: 'c',
        classes: 'w-1/1 maw-36rem  mt-',
        content: {
          type: 'timer',
          deadline: '{deadline}',
          text: '{timerText}',
          expiredText: '{expiredText}',
          classes: 'p0 {textColor} fw-800 fz-title-t lh-120 ta-c'
        }
      },
      '1170': {
        area: 'c',
        classes: 'w-1/1 maw-39rem  mt-',
        content: {
          type: 'timer',
          deadline: '{deadline}',
          text: '{timerText}',
          expiredText: '{expiredText}',
          classes: 'p0 {textColor} fw-800 fz-title-d lh-100 ta-c'
        }
      },
      '1440': {
        area: 'c',
        classes: 'w-1/1 maw-41rem  mt-',
        content: {
          type: 'timer',
          deadline: '{deadline}',
          text: '{timerText}',
          expiredText: '{expiredText}',
          classes: 'p0 {textColor} fw-800 fz-title-d lh-120 ta-c'
        }
      }
    }
  },
  {
    slot: {
      '0': {
        area: 'cb',
        classes: 'w-1/1 maw-24rem  mt-',
        content: {
          type: 'text',
          textlines: [
            {
              text: '{textline5}',
              classes: '{textColor} fw-600 fz-body-m lh-120 ta-c mt-1'
            },
            {
              text: '{textline6}',
              classes: '{textColor} fw-600 fz-body-m lh-120 ta-c'
            },
            {
              text: '{textline7}',
              classes: '{textColor} fw-600 fz-body-m lh-120 ta-c'
            },
            {
              text: '{textline8}',
              classes: '{textColor} fw-600 fz-body-m lh-120 ta-c'
            }
          ]
        }
      },
      '665': {
        area: 'cb',
        classes: 'w-1/1 w-24rem  mt-',
        content: {
          type: 'text',
          textlines: [
            {
              text: '{textline5}',
              classes: '{textColor} fw-600 fz-body-t lh-120 ta-c mt-1'
            },
            {
              text: '{textline6}',
              classes: '{textColor} fw-600 fz-body-t lh-120 ta-c'
            },
            {
              text: '{textline7}',
              classes: '{textColor} fw-600 fz-body-t lh-120 ta-c'
            },
            {
              text: '{textline8}',
              classes: '{textColor} fw-600 fz-body-t lh-120 ta-c'
            }
          ]
        }
      },
      '768': {
        area: 'cb',
        classes: 'w-1/1 maw-36rem ',
        content: {
          type: 'text',
          textlines: [
            {
              text: '{textline5}',
              classes: '{textColor} fw-600 fz-body-t lh-120 ta-c mt-1'
            },
            {
              text: '{textline6}',
              classes: '{textColor} fw-600 fz-body-t lh-120 ta-c'
            },
            {
              text: '{textline7}',
              classes: '{textColor} fw-600 fz-body-t lh-120 ta-c'
            },
            {
              text: '{textline8}',
              classes: '{textColor} fw-600 fz-body-t lh-120 ta-c'
            }
          ]
        }
      },
      '1170': {
        area: 'cb',
        classes: 'w-1/1 w-39rem ',
        content: {
          type: 'text',
          textlines: [
            {
              text: '{textline5}',
              classes: '{textColor} fw-600 fz-body-d lh-120 ta-c mt-1'
            },
            {
              text: '{textline6}',
              classes: '{textColor} fw-600 fz-body-d lh-120 ta-c'
            },
            {
              text: '{textline7}',
              classes: '{textColor} fw-600 fz-body-d lh-120 ta-c'
            },
            {
              text: '{textline8}',
              classes: '{textColor} fw-600 fz-body-d lh-120 ta-c'
            }
          ]
        }
      },
      '1440': {
        area: 'cb',
        classes: 'w-1/1 maw-41rem ',
        content: {
          type: 'text',
          textlines: [
            {
              text: '{textline5}',
              classes: '{textColor} fw-600 fz-body-d lh-120 ta-c mt-1'
            },
            {
              text: '{textline6}',
              classes: '{textColor} fw-600 fz-body-d lh-120 ta-c'
            },
            {
              text: '{textline7}',
              classes: '{textColor} fw-600 fz-body-d lh-120 ta-c'
            },
            {
              text: '{textline8}',
              classes: '{textColor} fw-600 fz-body-d lh-120 ta-c'
            }
          ]
        }
      }
    }
  },

  {
    slot: {
      '0': {
        area: 'cbb',
        classes: 'w-1/1 maw-21rem  mt-- ta-c',
        content: {
          type: 'link',
          text: '{ctaText}',
          action: '{ctaButtonAction}',
          url: '{ctaUrl}',
          classes: '{ctaColor} {ctaHoverColor} w-9rem fz-cta-m ta-c pv--'
        }
      },
      '665': {
        area: 'cbb',
        classes: 'w-1/1 maw-24rem  mt-- ta-c',
        content: {
          type: 'link',
          text: '{ctaText}',
          action: '{ctaButtonAction}',
          url: '{ctaUrl}',
          classes: ' {ctaColor} {ctaHoverColor} w-12rem fz-cta-t ta-c'
        }
      },
      '768': {
        area: 'cbb',
        classes: 'w-1/1 maw-36rem ph mt-- ta-c',
        content: {
          type: 'link',
          text: '{ctaText}',
          action: '{ctaButtonAction}',
          url: '{ctaUrl}',
          classes: '{ctaColor} {ctaHoverColor} w-12rem fz-cta-t ta-c'
        }
      },
      '1170': {
        area: 'cbb',
        classes: 'w-1/1 maw-39rem  ph+ mt-- ta-c',
        content: {
          type: 'link',
          text: '{ctaText}',
          action: '{ctaButtonAction}',
          url: '{ctaUrl}',
          classes: '{ctaColor} {ctaHoverColor} w-12rem fz-cta-d ta-c'
        }
      },
      '1440': {
        area: 'cbb',
        classes: 'w-1/1 maw-41rem  ph+ mt-- ta-c',
        content: {
          type: 'link',
          text: '{ctaText}',
          action: '{ctaButtonAction}',
          url: '{ctaUrl}',
          classes: '{ctaColor} {ctaHoverColor} w-18rem fz-cta-d ta-c'
        }
      }
    }
  },
  {
    slot: {
      '0': {
        area: 'cbbb',
        classes: 'w-1/1 maw-24rem  mt-',
        content: {
          type: 'text',
          textlines: [
            {
              text: '{textline9}',
              classes: 'p0 {textColor} fz-legal-m lh-120 ta-c'
            },
            {
              text: '{textline10}',
              classes: 'p0 {textColor} fz-legal-m lh-120 ta-c'
            },
            {
              text: '{textline11}',
              classes: 'p0 {textColor} fz-legal-m lh-120 ta-c'
            },
            {
              text: '{textline12}',
              classes: 'p0 {textColor} fz-legal-m lh-120 ta-c mb-1'
            }
          ]
        }
      },
      '665': {
        area: 'cbbb',
        classes: 'w-1/1 w-24rem  mtn+',
        content: {
          type: 'text',
          textlines: [
            {
              text: '{textline9}',
              classes: '{textColor}  fz-legal-t lh-120 ta-c mt-3'
            },
            {
              text: '{textline10}',
              classes: '{textColor}  fz-legal-t lh-120 ta-c'
            },
            {
              text: '{textline11}',
              classes: '{textColor}  fz-legal-t lh-120 ta-c'
            },
            {
              text: '{textline12}',
              classes: '{textColor}  fz-legal-t lh-120 ta-c mb-1'
            }
          ]
        }
      },
      '768': {
        area: 'cbbb',
        classes: 'w-1/1 maw-36rem ',
        content: {
          type: 'text',
          textlines: [
            {
              text: '{textline9}',
              classes: '{textColor}  fz-legal-t lh-120 ta-c'
            },
            {
              text: '{textline10}',
              classes: '{textColor}  fz-legal-t lh-120 ta-c'
            },
            {
              text: '{textline11}',
              classes: '{textColor}  fz-legal-t lh-120 ta-c'
            },
            {
              text: '{textline12}',
              classes: '{textColor}  fz-legal-t lh-120 ta-c mb-1'
            }
          ]
        }
      },
      '1170': {
        area: 'cbbb',
        classes: 'w-1/1 w-39rem ',
        content: {
          type: 'text',
          textlines: [
            {
              text: '{textline9}',
              classes: '{textColor}  fz-legal-d lh-120 ta-c'
            },
            {
              text: '{textline10}',
              classes: '{textColor}  fz-legal-d lh-120 ta-c'
            },
            {
              text: '{textline11}',
              classes: '{textColor}  fz-legal-d lh-120 ta-c'
            },
            {
              text: '{textline12}',
              classes: '{textColor}  fz-legal-d lh-120 ta-c mb-1'
            }
          ]
        }
      },
      '1440': {
        area: 'cbbb',
        classes: 'w-1/1 maw-41rem ',
        content: {
          type: 'text',
          textlines: [
            {
              text: '{textline9}',
              classes: '{textColor}  fz-legal-d lh-120 ta-c'
            },
            {
              text: '{textline10}',
              classes: '{textColor}  fz-legal-d lh-120 ta-c'
            },
            {
              text: '{textline11}',
              classes: '{textColor}  fz-legal-d lh-120 ta-c'
            },
            {
              text: '{textline12}',
              classes: '{textColor}  fz-legal-d lh-120 ta-c mb-1'
            }
          ]
        }
      }
    }
  }
]

const bannerTimerButton = makeButtonVersion(bannerTimer)

export default function getBannerTout(id, action) {
  let tout
  switch (id) {
    case 'left':
      if (action && action.length > 0) {
        tout = bannerLeftButton
      } else {
        tout = bannerLeft
      }
      break
    case 'center':
      if (action && action.length > 0) {
        tout = bannerCenterButton
      } else {
        tout = bannerCenter
      }
      break
    case 'right':
      if (action && action.length > 0) {
        tout = bannerRightButton
      } else {
        tout = bannerRight
      }
      break
    case 'timer':
      if (action && action.length > 0) {
        tout = bannerTimerButton
      } else {
        tout = bannerTimer
      }
      break
    default:
      throw new Error('Unknown tout id!')
  }
  return _.cloneDeep(tout)
}
